import React from 'react';
import { Spacer } from '@ontruck/orc';

const changeCrossDockDecisionsRenderer = ({ changes, ...props }) => {
  const decisionsBefore = changes?.decisions_before || [];
  const decisionsAfter = changes?.decisions_after || [];

  return (
    <Spacer {...props}>
      {decisionsBefore.join(', ')} &#8594; {decisionsAfter.join(', ')}
    </Spacer>
  );
};

export default changeCrossDockDecisionsRenderer;
